import { isProd } from "@/Env";

const devLogin = "https://dev-login.bhaptics.com";
const prodLogin = "https://login.bhaptics.com";
const devSdk = "https://dev-sdk-apis.bhaptics.com";
const prodSdk = "https://sdk-apis.bhaptics.com";
const devAdmin = "https://dev-admin-apis.bhaptics.com";
const prodAdmin = "https://admin-apis.bhaptics.com";

const login = isProd ? prodLogin : devLogin;
const sdk = isProd ? prodSdk : devSdk;
const admin = isProd ? prodAdmin : devAdmin;

const ApiHosts = {
  login,
  sdk,
  admin,
};

export default ApiHosts;
